<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 md:py-16">
        <div>
            <jet-authentication-card-logo />
        </div>

        <div v-if="$page.props.labels['invite.title'] || $page.props.labels['invite.text']" class="text-center my-8">
            <h3 class="text-xl mb-2" v-if="$page.props.labels['invite.title']">{{$page.props.labels['invite.title']}}</h3>
            <p class="text-base font-serif" v-if="$page.props.labels['invite.text']">{{$page.props.labels['invite.text']}}</p>
        </div>

        <div class="w-full mt-6 px-6 py-4 bg-white overflow-hidden">

            <jet-validation-errors class="mb-4 text-center" />

            <form class="max-w-xl mx-auto" @submit.prevent="submit">
                <div class="pr-4 mb-16" v-if="invite">
                    <h4 class="text-xl text-black mb-6">
                        Unternehmen
                    </h4>
                    <div class="mb-4">
                        <jet-label for="customer_nr" value="Kundenummer *" />
                        <jet-input id="customer_nr" disabled type="text" class="mt-1 opacity-40 block w-full" v-model="form.customer_nr" autocomplete="customer_nr" />
                    </div>
                    <div class="mb-4">
                        <jet-label for="company_name" value="Firmenname *" />
                        <jet-input id="company_name" type="text" class="mt-1 block w-full" v-model="form.company_name" autocomplete="company_name" />
                    </div>
                    <div class="grid grid-cols-6 gap-6">
                        <div class="col-span-6 sm:col-span-4 mb-4">
                            <jet-label for="street" value="Straße" />
                            <jet-input id="street" type="text" class="mt-1 block w-full" v-model="form.street" autocomplete="street" />
                        </div>
                        <div class="col-span-6 sm:col-span-2 mb-4">
                            <jet-label for="street_nr" value="Nr." />
                            <jet-input id="street_nr" type="text" class="mt-1 block w-full" v-model="form.street_nr" autocomplete="street_nr" />
                        </div>
                    </div>
                    <div class="grid grid-cols-6 gap-6">
                        <div class="col-span-6 sm:col-span-2 mb-4">
                            <jet-label for="postcode" value="PLZ" />
                            <jet-input id="postcode" type="text" class="mt-1 block w-full" v-model="form.postcode" autocomplete="postcode" />
                        </div>
                        <div class="col-span-6 sm:col-span-4 mb-4">
                            <jet-label for="city" value="Stadt" />
                            <jet-input id="city" type="text" class="mt-1 block w-full" v-model="form.city" autocomplete="city" />
                        </div>
                    </div>
                </div>

                <div>
                    <h4 class="text-xl text-black mb-6">
                        Persönliche Daten
                    </h4>
                    <div class="grid grid-cols-6 gap-6">
                        <div class="col-span-6 sm:col-span-3 mb-4">
                            <jet-label for="first_name" value="Vorname *" />
                            <jet-input id="first_name" type="text" class="mt-1 block w-full" v-model="form.first_name" required autofocus autocomplete="first_name" />
                        </div>
                        <div class="col-span-6 sm:col-span-3 mb-4">
                            <jet-label for="last_name" value="Nachname *" />
                            <jet-input id="last_name" type="text" class="mt-1 block w-full" v-model="form.last_name" required autofocus autocomplete="last_name" />
                        </div>
                    </div>
                    <div class="grid grid-cols-6 gap-6">
                        <div class="col-span-6 sm:col-span-3 mb-4">
                            <jet-label for="email" value="E-Mail *" />
                            <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required />
                        </div>
                        <div class="col-span-6 sm:col-span-3 mb-4">
                            <jet-label for="phone" value="Telefon" />
                            <jet-input id="phone" type="text" class="mt-1 block w-full" v-model="form.phone" />
                        </div>
                    </div>

                    <div class="mb-4">
                        <jet-label for="username" value="Benutzername" />
                        <jet-input id="username" type="text" class="mt-1 block w-full" v-model="form.username" />
                        <div class="text-xs italic mt-2">Kann für den Login alternativ zur E-Mail-Adresse verwendet werden. Benutzername ist optional.</div>
                    </div>

                    <div class="mb-4">
                        <jet-label for="password" value="Password *" />
                        <jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
                    </div>

                    <div class="mb-4">
                        <jet-label for="password_confirmation" value="Passwort Bestätigung *" />
                        <jet-input id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                    </div>
                </div>

                <div class="mt-6">
                    <jet-label for="terms">
                        <div class="flex items-start">
                            <jet-checkbox class="mt-1" name="Datenschutzerklärung" id="terms" v-model:checked="form.terms" />

                            <div class="ml-2">
                                Ja, ich habe die <a class="underline text-sm text-gray-600 hover:text-gray-900" target="_blank" href="https://www.backbord.de/datenschutz/">Datenschutzerklärung</a> gelesen und stimme hiermit der Speicherung und Verarbeitung meiner Daten zu. *
                            </div>
                        </div>
                    </jet-label>
                </div>

                <div class="flex items-center justify-end mt-16">
                    <Link v-if="!form.is_team_invitation" :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900 mr-auto">
                        Schon registriert?
                    </Link>

                    <jet-button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                        Registrieren
                    </jet-button>
                </div>
                <span class="text-gray-500 text-sm mt-8 inline-block">(*) Pflichtfelder</span>
            </form>
        </div>
    </div>
</template>

<script>
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
    import JetButton from '@/Jetstream/Button'
    import JetInput from '@/Jetstream/Input'
    import JetCheckbox from "@/Jetstream/Checkbox";
    import JetLabel from '@/Jetstream/Label'
    import JetValidationErrors from '@/Jetstream/ValidationErrors'
    import { Link } from '@inertiajs/inertia-vue3'

    export default {
        components: {
            Link,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
            JetInput,
            JetCheckbox,
            JetLabel,
            JetValidationErrors
        },

        props: ['invite', 'teamInvitation'],

        data() {
            return {
                form: this.$inertia.form({
                    invite_id: this.invite ? this.invite.id : null,
                    is_team_invitation: this.teamInvitation ? true : false,
                    team_invitation_token: this.teamInvitation ? this.teamInvitation.token : null,
                    company_name: this.invite ? this.invite.company_name : '',
                    customer_nr: this.invite ? this.invite.customer_nr : '',
                    street: this.invite ? this.invite.street : '',
                    street_nr: this.invite ? this.invite.street_nr : '',
                    postcode: this.invite ? this.invite.postcode : '',
                    city: this.invite ? this.invite.city : '',
                    first_name: this.invite ? this.invite.first_name : '',
                    last_name: this.invite ? this.invite.last_name : '',
                    phone: this.invite ? this.invite.phone : '',
                    email: this.invite
                      ? this.invite.email
                      : this.teamInvitation ? this.teamInvitation.email : '',
                    username: '',
                    password: '',
                    password_confirmation: '',
                    terms: false,
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('user.create'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation'),
                })
            }
        }
    }
</script>
